/**
 * App configs
 */
export const appConfig = {
  makyo: {
    CHANGE_LOG_URL: 'https://makyo.me/changelog',
  },
  sentry: {
    dsn: 'https://c9462b2363db463bb6eff4b50fa89af5@interceptor.makyo.me/1',
  },
  openReplay: {
    projectKey: 'DSpMExABoRquoeJGMY5C',
  },
  /**
   * Character count constraints for various element in makyo
   */
  charConstraints: {
    min: 2,
    max: 50,
  },
}
